const SCRIPT_KEY = '0de076e5-73b7-43ec-8634-180b6c3be3ab'
const SCRIPT_BASE_URL = 'https://jsd-widget.atlassian.com'
const SCRIPT_SRC = 'https://jsd-widget.atlassian.com/assets/embed.js'


export default function () {
    const install = () => {
        const script = document.createElement('script')
        script.id = 'jira-widget'
        script.setAttribute('data-key', SCRIPT_KEY)
        script.setAttribute('data-base-url', SCRIPT_BASE_URL)
        script.src = SCRIPT_SRC

        script.onerror = (error) => {
            console.error('Jira widget script install error')
            console.error(error)
        }

        script.onload = () => {
            console.log('Jira widget script installed')
        }

        document.head.append(script)
    }

    const destroy = () => {
        const script = document.head.querySelector('script#jira-widget')
        if (!script) return
        script.remove()
    }

    return { install, destroy }
}